import { type } from "os";

// 今天
export const dateToday = () => {
        let d = new Date()
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 今天最后时间
export const dateTodayLastTime = () => {
        let d = new Date()
        d.setHours(23, 59, 59)
        return d
    }
    // 昨天
export const dateYestoday = () => {
        let d = new Date()
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000)
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 昨天最后时间**
export const dateYestodayLastTime = () => {
        let d = new Date()
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000)
        d.setHours(23, 59, 59)
        return d
    }
    // 前天
    export const dateTwoYestoday = () => {
        let d = new Date()
        d.setTime(d.getTime() - 48 * 60 * 60 * 1000)
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 本周周一
export const dateCurrentWeekendFirstDay = () => {
        let d = new Date()
        let day = d.getDay()
        if (day === 0) {
            day = 7;
        }
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000 * (day - 1))
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 本周周一最后时间(最后一天)
export const dateCurrentWeekendLastTime = () => {
        let d = new Date()
        let day = d.getDay()||7
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * (7 - day))
        d.setHours(23, 59, 59)
        return d
    }
    // 上一周的周一
export const datePrevWeekendFirstDay = () => {
        let d = new Date()
        let day = d.getDay()||7
        let dis = 24 * 60 * 60 * 1000 * (day - 1) + 24 * 60 * 60 * 1000 * (7)
        d.setTime(d.getTime() - dis)
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 上一周最后时间(周末)
export const datePrevWeekendLastTime = () => {
        let d = new Date()
        let day = d.getDay()||7
            // 这个星期已经话费的时间,包括周末在内
        let dis = 24 * 60 * 60 * 1000 * (day)
        d.setTime(d.getTime() - dis)
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 本月第一天
export const getCurrentMonthFirstDay = () => {
        let d = new Date()
        d.setDate(1)
        d.setHours(0, 0, 0, 0)
        return d
    }
    // new Date(2017,2,0)
    // 这个月的最后一天
export const getCurrentMonthLastTime = () => {
    let d = new Date()
    let d2 = new Date(d.getFullYear(), d.getMonth() + 1, 0)
    let dayLength = d2.getDate()
    d.setDate(dayLength)
    d.setHours(23, 59, 59)
    return d
}

// 前一个月的第一天
export const prevMonthFirstDay = () => {
        let d=new Date()
        d.setDate(0)
        d.setDate(1)
        d.setHours(0, 0, 0, 0)
        return d
    }
    // 前一个月的最后一天最后时间
export const prevMonthLastTime = () => {
    let d=new Date()
    d.setDate(0)
    d.setHours(23, 59, 59)
    return d
}

//是否是今天
export const isToday = (str) => {
    if (typeof str == 'string')
        var d = new Date(str.replace(/-/g, "/"));
    else if (typeof str == 'number' || typeof str == 'object') {
        var d = new Date(str);
    }
    var todaysDate = new Date();
    if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
        return true;
    } else {
        return false;
    }
}

export const getSomeDay = (AddDayCount = 0) => {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期  
    dd.setHours(0, 0, 0, 0)
    return dd;
}

export const checkDateType = (date) => {
    if (typeof date == 'object' && date instanceof Date) {
        return date
    } else if (typeof date == 'string') {
        return strToDate(date)
    } else if (typeof date == 'number') {
        return new Date(date)
    } else {
        return null;
    }
}

export const strToDate = (str) => {
    let vstr = str.replace(/-/g, '/');
    return new Date(vstr);
}

// 将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) 
// 例子： 
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18 
export const Format = (time, fmt) => {
    var o = {
        'M+': time.getMonth() + 1, // 月份 
        'd+': time.getDate(), // 日 
        'h+': time.getHours(), // 小时 
        'm+': time.getMinutes(), // 分 
        's+': time.getSeconds(), // 秒 
        'q+': Math.floor((time.getMonth() + 3) / 3), // 季度 
        'S': time.getMilliseconds(), // 毫秒 
        'W': ['日', '一', '二', '三', '四', '五', '六'][time.getDay()] //星期
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    return fmt
}